import { setPagingParams } from '../functions/createPagingParams';
import { County } from '../models/county';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'County';

export const getCountys = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}`;
  return AxiosInstance.get<PagedResult<County>>(endpoint);
};
